export const scrollToSection = (id, targetRoute) => {
  if (typeof window === "undefined" || typeof document === "undefined") return;

  // If a target route is provided and the current path doesn't match, redirect with the hash.
  if (targetRoute && window.location.pathname !== targetRoute) {
    window.location.href = `${targetRoute}#${id}`;
    return;
  }

  // Otherwise, attempt to scroll to the element on the current page.
  const element = document.getElementById(id);
  if (element) {
    const topPosition = element.offsetTop;
    window.scrollTo({
      top: topPosition - 60, // adjust offset as needed
      behavior: "smooth",
    });
  }
};
